module.exports = __webpack_public_path__ + "img/apple-left.6766cdb8.png";